var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLabListEmptyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 73,
    viewBox: "0 0 80 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.0625,
    y: 12.7617,
    width: 70.8861,
    height: 49.6203,
    rx: 8.10127,
    fill: "#CAD3DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2936 37.2178C48.867 36.8339 58.7821 25.9709 55.189 18.3314C52.9056 13.4764 44.5208 13.4218 44.0498 19.7996C43.2888 30.1038 56.7935 27.0345 61.6823 21.6795C66.5711 16.3246 66.6843 5.3162 63.6464 0.759746",
    stroke: "#96A4B1",
    strokeWidth: 1.51899,
    strokeLinecap: "round",
    strokeDasharray: "3.04 3.04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.28554 32.1082C0.606251 27.2363 4.39013 22.8882 9.30919 22.8882H29.6755C32.4656 22.8882 34.9716 24.5954 35.9928 27.192C37.0139 29.7885 39.5199 31.4958 42.31 31.4958H52.3544H55.7396H70.6486C75.5822 31.4958 79.3703 35.8684 78.6671 40.7517L75.0944 65.5618C74.5203 69.5489 71.104 72.5084 67.0759 72.5084H13.9686C9.92668 72.5084 6.50313 69.5291 5.94496 65.5259L1.28554 32.1082Z",
    fill: "#E1E5EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabListEmptyIcon);
export default __webpack_public_path__ + "static/media/lab-list__empty-icon.724ac18f32d4d1e46c350fd18d462751.svg";
export { ForwardRef as ReactComponent };